import React from 'react';
import classes from './StatsCardSkeleton.module.css';
import CommonCard from '../CommonCard';
import clsx from 'clsx';

const StatsCardSkeleton = ({ cardName }) => {
  return (
    <CommonCard className={clsx(classes.card, {})}>
      <h2 className={classes.heading}>{cardName}</h2>
      <h3 className={classes.amountHeading}>-</h3>
      <p className={classes.waived}>-</p>
    </CommonCard>
  );
};

export default StatsCardSkeleton;
